export default "__VITE_ASSET__CSxBPVSX__"